
import { createRouter, createWebHistory } from "vue-router";

import { useInteractiveStore } from '@/stores/interactive'
import { useSettingStore } from '@/stores/settings'
import { useAdminStore } from "@/stores/admin";

const router = createRouter({

history: createWebHistory(process.env.BASE_URL),

routes: [
  {
    path: "/",
    redirect: '/account/dashboard',
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/Register.vue"),
    meta: {
      title: "Create an Account"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: {
      title: "Login"
    }
  },
  {
    path: '/email-activation',
    name: 'email-activation',
    component: () => import('../views/Email-Activation.vue'),
    meta: {
      title: 'Email Verification'
    }
  },
  {
    path: '/email-confirmation/:id',
    name: 'email-confirmation',
    component: () => import('../views/Email-Confirmation.vue'),
    meta: {
      title: 'Email Confirmation'
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/Forgot-Password.vue'),
    meta: {
      title: 'Reset Your Password'
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/Reset-Password.vue'),
    meta: {
      title: 'New Password'
    }
  },

  //DASHBOARD PAGES
  {
    path: '/account/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      title: 'Dashboard',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/add-student',
    name: 'Add-Student',
    component: () => import('../views/Add-Student.vue'),
    meta: {
      title: 'Add Student',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/edit-student/:id',
    name: 'editstudent',
    component: () => import('../views/Edit-Student.vue'),
    meta: {
      title: 'Edit Student',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/manage-guardians/:id',
    name: 'Manage-Guardians',
    component: () => import('../views/Manage-Guardians.vue'),
    meta: {
      title: 'Manage Guardians',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/students',
    name: 'students',
    component: () => import('../views/Students.vue'),
    meta: {
      title: 'Students',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/student-profile/:id',
    name: 'Student Profile',
    component: () => import('../views/Student-Profile.vue'),
    meta: {
      title: 'Student Profile',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/student-promotion',
    name: 'Student Promotion',
    component: () => import('../views/Student-Promotion.vue'),
    meta: {
      title: 'Student Promotion',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/id-card-generator',
    name: 'Id Card Generator',
    component: () => import('../views/Id-Card-Generator.vue'),
    meta: {
      title: 'Id Card Generator',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/attendance',
    name: 'Mark Attendance',
    component: () => import('../views/Attendance.vue'),
    meta: {
      title: 'Mark Attendance',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/attendance-summary',
    name: 'Attendance Summary',
    component: () => import('../views/Attendance-Summary.vue'),
    meta: {
      title: 'Attendance Summary',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/session-terms-management',
    name: 'Session Terms Management',
    component: () => import('../views/Session-Terms-Management.vue'),
    meta: {
      title: 'Session And Terms Management',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/class-arms-management',
    name: 'Class Arms Management',
    component: () => import('../views/Class-Arms-Management.vue'),
    meta: {
      title: 'Class And Arms Management',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/holidays',
    name: 'Holidays',
    component: () => import('../views/Holidays.vue'),
    meta: {
      title: 'Holidays',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/add-fee-type',
    name: 'Add-Fee-Type',
    component: () => import('../views/Add-Fee-Type.vue'),
    meta: {
      title: 'Add Fee-Type',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  
  {
    path: '/account/fee-types',
    name: 'Fee-Types',
    component: () => import('../views/Fee-Types.vue'),
    meta: {
      title: 'Fee Types',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/edit-fee-type/:id',
    name: 'editFeeType',
    component: () => import('../views/Edit-Fee-Type.vue'),
    meta: {
      title: 'Edit Fee Type',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/add-fee-structure',
    name: 'Add-Fee-Structure',
    component: () => import('../views/Add-Fee-Structure.vue'),
    meta: {
      title: 'Add Fee Structure',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/fee-structures',
    name: 'Fee-Structures',
    component: () => import('../views/Fee-Structures.vue'),
    meta: {
      title: 'Fee Stuctures',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/edit-fee-structure/:id',
    name: 'editFeeStructure',
    component: () => import('../views/Edit-Fee-Structure.vue'),
    meta: {
      title: 'Edit Fee Structure',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/invoices',
    name: 'Invoices',
    component: () => import('../views/Invoices.vue'),
    meta: {
      title: 'Invoices',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/generate-invoice',
    name: 'GenerateInvoice',
    component: () => import('../views/Generate-Invoice.vue'),
    meta: {
      title: 'Generate Invoices',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/invoice-detail/:id',
    name: 'InvoiceDetail',
    component: () => import('../views/Invoice-Detail.vue'),
    meta: {
      title: 'Invoice Detail',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/record-payment',
    name: 'RecordPayment',
    component: () => import('../views/Record-Payment.vue'),
    meta: {
      title: 'Record Payment',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/payment-channels',
    name: 'PaymentChannels',
    component: () => import('../views/Payment-Channels.vue'),
    meta: {
      title: 'Payment Channels',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/add-payment-channel',
    name: 'AddPaymentChannel',
    component: () => import('../views/Add-Payment-Channel.vue'),
    meta: {
      title: 'Add Payment Channel',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/edit-payment-channel/:id',
    name: 'EditPaymentChannel',
    component: () => import('../views/Edit-Payment-Channel.vue'),
    meta: {
      title: 'Edit Payment Channel',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/collections-report',
    name: 'DailyCollectionsReport',
    component: () => import('../views/Collections-Report.vue'),
    meta: {
      title: 'Collections Report',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/outstanding-balances-report',
    name: 'OutstandingBalancesReport',
    component: () => import('../views/Outstanding-Balances-Report.vue'),
    meta: {
      title: 'Outstanding Balances Report',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/termly-revenue-summary',
    name: 'TermlyRevenueSummary',
    component: () => import('../views/Termly-Revenue-Summary.vue'),
    meta: {
      title: 'Termly Revenue Summary',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/subjects',
    name: 'Subjects',
    component: () => import('../views/Subjects.vue'),
    meta: {
      title: 'Subjects',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/add-subject',
    name: 'AddSubject',
    component: () => import('../views/Add-Subject.vue'),
    meta: {
      title: 'Add Subject',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/edit-subject/:id',
    name: 'EditSubject',
    component: () => import('../views/Edit-Subject.vue'),
    meta: {
      title: 'Edit Subject',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/subject-assignment',
    name: 'SubjectAssignment',
    component: () => import('../views/Subject-Assignment.vue'),
    meta: {
      title: 'Subject Assignment',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/result-settings',
    name: 'ResultSettings',
    component: () => import('../views/Result-Settings.vue'),
    meta: {
      title: 'Result Settings',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/print-report-card',
    name: 'PrintReportCard',
    component: () => import('../views/Print-Report-Card.vue'),
    meta: {
      title: 'Print Report Card',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/enter-result',
    name: 'EnterResult',
    component: () => import('../views/Enter-Result.vue'),
    meta: {
      title: 'Enter Result',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/staffs',
    name: 'staffs',
    component: () => import('../views/Staffs.vue'),
    meta: {
      title: 'Staffs',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/staff/:id/classes',
    name: 'Assigned Classes',
    component: () => import('../views/Assign-Classes.vue'),
    meta: {
      title: 'Assigned Classes',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/broadsheet',
    name: 'Broadsheet',
    component: () => import('../views/Broadsheet.vue'),
    meta: {
      title: 'Broadsheet',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
  path: '/account/create-announcement',
  name: 'CreateAnnouncement',
  component: () => import('../views/Create-Announcement.vue'),
  meta: {
    title: 'Create Announcement',
    requiresAuth: true,
    authorize_roles: ['super_admin', 'head_teacher']
  }
 },
  {
    path: '/account/announcements',
    name: 'Announcements',
    component: () => import('../views/Announcements.vue'),
    meta: {
      title: 'Announcements',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: {
      title: 'Profile',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher','teacher']
    }
  },
  {
    path: '/account/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue'),
    meta: {
      title: 'Settings',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/help',
    name: 'Help',
    component: () => import('../views/Help.vue'),
    meta: {
      title: 'Help',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher', 'teacher']
    }
  },
  {
    path: '/account/bulk-operations',
    name: 'BulkOperations',
    component: () => import('../views/Bulk-Operations.vue'),
    meta: {
      title: 'Bulk Operations',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
  {
    path: '/account/results-collation-status',
    name: 'ResultsCollationStatus',
    component: () => import('../views/Results-Collation-Status.vue'),
    meta: {
      title: 'Results Collation Status',
      requiresAuth: true,
      authorize_roles: ['super_admin', 'head_teacher']
    }
  },
],

scrollBehavior(to, from, savedPosition) {
  
  if (to.name === 'dashboard') {
   
    return savedPosition || {};

  }

  return { top: 0 }; // Scroll to the top
  
}

})

router.beforeEach(async (to, from, next) => {

  const admin_store = useAdminStore();
  const settings_store    = useSettingStore()

  // Ensure admin data loaded
   // ── Wait for both user and settings if not fetched yet ──
   if (!admin_store.isFetched) {
    await Promise.all([
      admin_store.fetch_admin().catch(() => {}),
      settings_store.fetch_settings().catch(() => {})
    ])
  }

  const site = settings_store.settings?.website || ''

  document.title = to.meta.title
    ? `${to.meta.title} - ${site}`
    : `${site} | School System.`

  // Route requires login but user not logged in
  if (to.meta.requiresAuth && !admin_store.isAuthenticated) {
    return next({ name: "login" });
  }

  // Route requires roles → check role permission
  if (to.meta.authorize_roles) {

    const allowedRoles = to.meta.authorize_roles;

    const admin_role = admin_store.admin?.role;

    if (!allowedRoles.includes(admin_role)) {
      return next({ name: "dashboard" });
    }

  }

  // Logged in users shouldn't access login/register pages
  if (!to.meta.requiresAuth && admin_store.isAuthenticated) {
    return next({ name: "dashboard" });
  }

  next();

});



router.afterEach((to, from, next) => { // use am close sidebar after each page navigation on mobile sha
  
  const interactive_store = useInteractiveStore()

  if (window.innerWidth < 992) {

  interactive_store.Close_Sidebar()

  }

})


 
export default router;
